import { ConfirmationService } from '@services/sys/confirmation.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Component, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'app-z-input',
    templateUrl: './z-input.component.html',
    styleUrl: './z-input.component.less',
})
export class ZInputComponent implements OnChanges {
    @ViewChild('editorTextArea') editorTextArea!: ElementRef;
    @ViewChild('inputNumberCom') inputNumberCom!: ElementRef;
    @Input() initialValue: string = '';  // 父组件传递的初始值
    @Input() placeholder = 'Click to edit';
    @Input() required = false;
    @Input() rows = 1;
    @Input() valueType = 'Text';
    @Input() saveLoading = false;
    @Input() inactiveUsers: boolean = false;
    @Output() valueSaved = new EventEmitter<string>();  // 父组件监听保存事件
    @Output() focusEvent = new EventEmitter<void>();
    @Output() blurEvent = new EventEmitter<void>();
    @Output() valueRejected = new EventEmitter<void>();

    isHovered = false;
    isEditing = false;
    currentValue: string = this.initialValue;  // 当前显示的值
    inputValue: string = this.currentValue;    // 输入框中的值
    private originalValue: string = this.initialValue;

    constructor(private message: NzMessageService,
                private confirmationService: ConfirmationService) {
    }

    ngOnChanges(): void {
        this.currentValue = this.initialValue;  // 当输入的值发生变化时，更新显示值
        this.inputValue = this.currentValue;
    }

    onMouseEnter(): void {
        if (!this.isEditing) {
            this.isHovered = true;
        }
    }

    onMouseLeave(): void {
        this.isHovered = false;
    }

    startEditing(): void {
        console.log('startEditing');
        this.isEditing = true;
        this.isHovered = false;  // 进入编辑状态时去除背景色
        this.originalValue = this.currentValue;
        setTimeout(() => {
            if (this.editorTextArea) {
                this.editorTextArea.nativeElement.focus();
            }
            this.focusEvent.emit(); // Emit focus event
        });
    }

    onBlur(): void {
        let inputValue = this.inputValue;
        if (this.valueType === 'Text' && inputValue != null && inputValue !== '') {
            inputValue = inputValue.trim();
        }
        this.confirmationService.confirmUpdateTask(this.inactiveUsers, () => {
            this.isEditing = false;
            // Emit blur event
            this.blurEvent.emit();
            if (this.required && !(inputValue || inputValue.toString() === '0')) {
                this.message.error('This field is required');
                this.inputValue = this.currentValue;  // 恢复成之前的值
                this.valueRejected.emit();
                return;
            }
            // 没有改变
            if (inputValue === this.currentValue) {
                return;
            }
            this.currentValue = this.inputValue;  // 保存新值
            this.valueSaved.emit(this.currentValue);  // 触发保存事件
            }, () => { this.handleCancel(); }
        );
    }

    // 阻止回车换行
    onKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();  // 阻止默认的回车换行行为
        }
    }


    handleCancel(): void {
        this.inputValue = this.currentValue;  // 恢复成之前的值
        this.isEditing = false;
        console.log('cancel', this.isEditing);
    }

    revertValue(): void {
        this.inputValue = this.originalValue;
        this.currentValue = this.originalValue;
        setTimeout(() => {
            if (this.editorTextArea) {
                this.editorTextArea.nativeElement.value = this.originalValue;
            }
        },100);
    }
}
